import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { getPersistConfig } from 'redux-deep-persist';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import settingsReducer from '@/store/settings/settingsReducer';

const rootReducer = combineReducers({
    appSettings: settingsReducer,
});

const persistConfig = getPersistConfig({
    key: 'root',
    storage,
    rootReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export type RootState = ReturnType<typeof store.getState>;
export const selectSelf = (state: RootState) => state;
